(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4040],{

/***/ 5307:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user-profile/notifycations",
      function () {
        return __webpack_require__(15919);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Notifycations; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./pages/user-profile/profileLayout/index.js
var profileLayout = __webpack_require__(33713);
// EXTERNAL MODULE: ./setup/flexbiz-api-provider/index.js + 4 modules
var flexbiz_api_provider = __webpack_require__(34733);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fi/FiChevronLeft.js
var FiChevronLeft = __webpack_require__(2335);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
// EXTERNAL MODULE: ./apis/fetch.js
var fetch = __webpack_require__(36203);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./utils/sanitizeDOMData.js
var utils_sanitizeDOMData = __webpack_require__(60959);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(10166);
;// CONCATENATED MODULE: ./pages/user-profile/notifycations/components/NotificationItem.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 0.3px solid rgba(0, 0, 0, 0.1);\n  border-top: 0.3px solid rgba(0, 0, 0, 0.1);\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 5px;\n  width: 100%;\n  transition: 0.3s;\n  cursor: pointer;\n  &:hover {\n    box-shadow: 2px 1px 6px rgba(0, 0, 0, 0.19);\n    div {\n      div {\n        -webkit-line-clamp: 2;\n        /* height: 80px;\n        transition: height 2s; */\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  padding-top: 5px;\n  color: #7c8182;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 20px;\n  -webkit-line-clamp: 1;\n  height: 20px;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  opacity: ",
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 20px;\n  -webkit-line-clamp: 2;\n  height: 40px;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  padding-left: 10px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject(), function(props) {
    return props.bgColor ? props.bgColor : "inherit";
});
var Hover = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1());
var Datep = emotion_styled_browser_esm/* default.p */.Z.p(_templateObject2());
var TitleNoti = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3());
var Noti = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject4(), function(props) {
    props.active ? 1 : 0.5;
});
function NotificationItem_NotificationItem(param) {
    var data = param.data, setReFetch = param.setReFetch;
    //   console.log(data);
    var context = useApiContext();
    var handleDelete = function() {
        var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee(id) {
            var ref;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        _ctx.next = 4;
                        return context.apis.asyncDeleteList(context === null || context === void 0 ? void 0 : (ref = context.userInfo) === null || ref === void 0 ? void 0 : ref.token, "notification", id);
                    case 4:
                        //   console.log(a);
                        setReFetch(function(prev) {
                            return prev + 1;
                        });
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log(_ctx.t0);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function handleDelete(id) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx(Wrapper, {
        children: /*#__PURE__*/ _jsxs(Grid, {
            children: [
                /*#__PURE__*/ _jsx(Grid.Col, {
                    span: 10,
                    children: /*#__PURE__*/ _jsxs(Hover, {
                        children: [
                            /*#__PURE__*/ _jsx(TitleNoti, {
                                children: sanitizeDOMData(data === null || data === void 0 ? void 0 : data.title)
                            }),
                            /*#__PURE__*/ _jsx(Noti, {
                                children: sanitizeDOMData(data === null || data === void 0 ? void 0 : data.content)
                            }),
                            /*#__PURE__*/ _jsx(Datep, {
                                children: new Date(data === null || data === void 0 ? void 0 : data.date_updated).toLocaleDateString("vi", {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Grid.Col, {
                    span: 2,
                    sx: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ _jsx(Button, {
                        sx: {
                            color: "red",
                            background: "white",
                            height: "100%",
                            width: "100%",
                            padding: 0
                        },
                        onClick: function() {
                            return handleDelete(data === null || data === void 0 ? void 0 : data._id);
                        },
                        children: "Xo\xe1"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./pages/user-profile/notifycations/components/NotificationList.js












function NotiList() {
    var context = useApiContext();
    var router = useRouter();
    var ref = _sliced_to_array(React.useState(null), 2), noti = ref[0], setNoti = ref[1];
    var ref1 = _sliced_to_array(React.useState(1), 2), reFetch = ref1[0], setReFetch = ref1[1];
    var id_app = getIdApp("so1", {});
    React.useEffect(function() {
        if (!localStorage.getItem("token")) {
            context.setProgressStatus(false);
            router.push({
                pathname: "/dang-nhap"
            });
        }
    }, [
        context
    ]);
    React.useEffect(function() {
        function fetch() {
            return _fetch.apply(this, arguments);
        }
        function _fetch() {
            _fetch = _async_to_generator(regeneratorRuntime.mark(function _callee() {
                var ref, ref1, _obj, list;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            ;
                            _ctx.next = 5;
                            return asyncGetList({
                                access_token: context === null || context === void 0 ? void 0 : (ref = context.userInfo) === null || ref === void 0 ? void 0 : ref.token,
                                collection_name: "notification",
                                options: {
                                    limit: 10,
                                    condition: (_obj = {}, _define_property(_obj, "exfields.id_app", id_app), _define_property(_obj, "email_owner", context === null || context === void 0 ? void 0 : (ref1 = context.userInfo) === null || ref1 === void 0 ? void 0 : ref1.email), _obj)
                                }
                            });
                        case 5:
                            list = _ctx.sent;
                            // console.log(list);
                            setNoti(list);
                            _ctx.next = 12;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9
                    ]
                ]);
            }));
            return _fetch.apply(this, arguments);
        }
        (context === null || context === void 0 ? void 0 : context.userInfo) && fetch();
    }, [
        context.userInfo,
        reFetch
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(Title, {
                order: 4,
                children: "Th\xf4ng b\xe1o của t\xf4i"
            }),
            noti && noti.map(function(item, index) {
                return /*#__PURE__*/ _jsx(NotificationItem, {
                    data: item,
                    setReFetch: setReFetch
                }, index);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/user-profile/notifycations/index.page.js





// import { FiChevronLeft } from "@react-icons/all-files/bs/BsChevronLeft";




function Notifycations() {
    var isTablet = (0,useWindowSize/* default */.Z)().isTablet;
    var context = (0,flexbiz_api_provider/* useApiContext */.Q)();
    var router = (0,next_router.useRouter)();
    react.useEffect(function() {
        if (!localStorage.getItem("token")) {
            context.setProgressStatus(false);
            router.push({
                pathname: "/dang-nhap"
            });
        }
    }, [
        context
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isTablet ? /*#__PURE__*/ (0,jsx_runtime.jsx)(profileLayout/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                padding: 20
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    width: "100%",
                    padding: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FiChevronLeft/* FiChevronLeft */.Y, {
                        size: 30,
                        onClick: function() {
                            return router.push("/user-profile");
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        align: "center",
                        size: "lg",
                        sx: {
                            width: "100%"
                        },
                        children: "Sổ địa chỉ"
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 33713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProfileLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _common_Layout_Container_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6559);
/* harmony import */ var _common_Layout_Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25478);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26679);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93284);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62679);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69469);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(95117);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);









function ProfileLayout(param) {
    var children = param.children;
    // const size = useWindowSize();
    var trans = (0,_hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var route = [
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.info,
            href: "/user-profile/my-profile"
        },
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.address,
            href: "/user-profile/address-book"
        },
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.purchase,
            href: "/user-profile/purchased-return"
        },
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.liked,
            href: "/user-profile/liked-product"
        }, 
    ];
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().pathname;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_6__.useState([
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.home,
            href: "/"
        },
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.title,
            href: "/user-profile"
        }, 
    ]), 2), routes = ref[0], setRoutes = ref[1];
    react__WEBPACK_IMPORTED_MODULE_6__.useEffect(function() {
        var state = [
            {
                title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.home,
                href: "/"
            },
            {
                title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.title,
                href: "/user-profile"
            }, 
        ];
        route.map(function(item) {
            pathname.indexOf(item.href) >= 0 && state.push(item);
        });
        setRoutes(state);
    }, [
        pathname
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Layout_Container_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: {
                padding: "20px 0px"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Breadcrumbs */ .O, {
                    children: routes === null || routes === void 0 ? void 0 : routes.map(function(item, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                            scroll: false,
                            href: item.href,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.title
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Grid */ .r, {
                    sx: {
                        padding: "30px 0px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Grid.Col */ .r.Col, {
                            xs: 3,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .SimpleGrid */ .M, {
                                cols: 1,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        scroll: false,
                                        href: "/user-profile",
                                        sx: {},
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                            transform: "uppercase",
                                            weight: pathname === "/user-profile" ? 700 : 500,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: trans === null || trans === void 0 ? void 0 : trans.profile.layout.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        scroll: false,
                                        href: "/user-profile/my-profile",
                                        sx: {},
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                            transform: "uppercase",
                                            weight: pathname.indexOf("/my-profile") >= 0 ? 700 : 500,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: trans === null || trans === void 0 ? void 0 : trans.profile.layout.info
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        scroll: false,
                                        href: "/user-profile/address-book",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                            transform: "uppercase",
                                            weight: pathname.indexOf("/address-book") >= 0 ? 700 : 500,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: trans === null || trans === void 0 ? void 0 : trans.profile.layout.address
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        scroll: false,
                                        href: "/user-profile/purchased-return",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                            transform: "uppercase",
                                            weight: pathname.indexOf("/purchased-return") >= 0 ? 700 : 500,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: trans === null || trans === void 0 ? void 0 : trans.profile.layout.purchase
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        scroll: false,
                                        href: "/user-profile/liked-product",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                            transform: "uppercase",
                                            weight: pathname.indexOf("/liked-product") >= 0 ? 700 : 500,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: trans === null || trans === void 0 ? void 0 : trans.profile.layout.liked
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Grid.Col */ .r.Col, {
                            xs: 9,
                            children: children
                        })
                    ]
                })
            ]
        })
    });
};
ProfileLayout.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    children: page
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Layout_Footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};


/***/ }),

/***/ 60959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ sanitizeDOMData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25935);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__);





var parseOptions = {
    replace: function(param) {
        var attribs = param.attribs, children = param.children;
        if (!attribs) {
            return;
        }
        if (attribs.dir === "ltr") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* .domToReact */ .du)(children)
            });
        }
    }
};
function sanitizeDOMData(htmlString) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        replace: parseOptions.replace
    };
    var cleanString = isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize(htmlString, {
        USE_PROFILES: {
            html: true
        }
    });
    var html = (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(cleanString, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, options), {
        trim: true
    }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "webview",
        children: html
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3987,4077,9774,2888,179], function() { return __webpack_exec__(5307); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);